import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (pw !== confirm) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      await http.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated — sign in with your new password");
      nav("/login");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-zinc-100 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border-2 border-zinc-900 shadow-brutal p-8" data-testid="reset-password-card">
        <div className="label-overline text-blue-600 mb-1">Account Recovery</div>
        <h1 className="font-display text-3xl font-black tracking-tighter uppercase">Choose a new password</h1>
        {!token ? (
          <div className="mt-6 border-l-4 border-red-600 bg-red-50 p-4 text-sm text-red-800" data-testid="reset-no-token">
            Missing reset token. Please use the link from your email or <Link to="/forgot-password" className="underline">request a new one</Link>.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
            <div>
              <label className="label-overline text-zinc-700 block mb-1">New Password</label>
              <Input type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)}
                     data-testid="reset-new" className="rounded-none border-zinc-400" />
            </div>
            <div>
              <label className="label-overline text-zinc-700 block mb-1">Confirm New Password</label>
              <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
                     data-testid="reset-confirm" className="rounded-none border-zinc-400" />
            </div>
            <Button type="submit" disabled={busy} data-testid="reset-submit"
                    className="w-full rounded-none h-11 bg-blue-600 hover:bg-blue-700 text-white font-mono uppercase tracking-widest text-xs">
              {busy ? "Updating…" : "Update Password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
